import React, { Fragment, useContext } from "react";
import OnColorContext from "../../../../contexts/OnColorContext";
import TextAtm from "../../../atoms/TextAtm";
import PushOrg from "../../../organisms/PushOrg";
import { MobileItemsBox, MobilePriceBox, MobilePromotionText, MobileRenewalPrice, StyledMobileProductBoxMol } from "./MobileProductBoxMol.styled";
function MobileProductBoxMol(_ref) {
  var items = _ref.items,
    promotionText = _ref.promotionText,
    renewalPrice = _ref.renewalPrice,
    ariaLabels = _ref.ariaLabels;
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledMobileProductBoxMol, {
    $hasPromotionText: !!promotionText,
    $onColor: onColor,
    role: "row",
    "aria-label": ariaLabels.rowLabel
  }, /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 3,
    rightSpace: 3,
    bottomSpace: renewalPrice ? 0 : 3,
    hasNoReset: true
  }, promotionText ? /*#__PURE__*/React.createElement(MobilePromotionText, {
    typography: "xsmall2",
    color: "white",
    align: "center"
  }, promotionText) : null, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 1.5
  }, items[0].text), /*#__PURE__*/React.createElement(MobileItemsBox, null, items.slice(1, items.length - 1).map(function (item) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: item.title
    }, /*#__PURE__*/React.createElement(TextAtm, {
      typography: "tiny2"
    }, item.title, ": "), /*#__PURE__*/React.createElement("div", null, item.text));
  })), /*#__PURE__*/React.createElement(MobilePriceBox, {
    justifyContent: "space-between",
    alignItems: "center",
    direction: "column",
    $onColor: onColor
  }, items[items.length - 1].text)), renewalPrice ? /*#__PURE__*/React.createElement(MobileRenewalPrice, null, renewalPrice) : undefined);
}
export default MobileProductBoxMol;